import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useRef } from 'react';
export var useIntersectionObserver = function useIntersectionObserver() {
  var elRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isIntersecting = _useState2[0],
      setIsIntersecting = _useState2[1];

  var observer = useRef(new window.IntersectionObserver(function (changes) {
    changes.forEach(function (change) {
      if (change.isIntersecting) setIsIntersecting(true);
    });
  }, {}));
  useEffect(function () {
    if (observer.current && elRef.current) {
      observer.current.observe(elRef.current);
    } else console.error("Image loader was loaded without \n      ".concat(!observer.current ? 'Observer' : '', " ").concat(!elRef.current ? 'ObserverElement' : ''));

    return function () {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (observer.current) observer.current.disconnect();
    };
  }, []);
  return {
    elRef: elRef,
    isIntersecting: isIntersecting
  };
};